import React from 'react';

export default function TransactionIcon() {
  return (
    <svg
      width="18"
      height="10"
      viewBox="0 0 22 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 11.75L11 1.75L21 11.75"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
